var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinSmall = function SvgLinkedinSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.186523,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 3.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1865 6.5H7.1834C6.6334 6.5 6.18652 6.95313 6.18652 7.50938V19.4906C6.18652 20.0469 6.6334 20.5 7.1834 20.5H19.1865C19.7365 20.5 20.1865 20.0469 20.1865 19.4906V7.50938C20.1865 6.95313 19.7365 6.5 19.1865 6.5ZM10.4178 18.5H8.34277V11.8187H10.4209V18.5H10.4178ZM9.38027 10.9062C8.71465 10.9062 8.17715 10.3656 8.17715 9.70312C8.17715 9.04063 8.71465 8.5 9.38027 8.5C10.0428 8.5 10.5834 9.04063 10.5834 9.70312C10.5834 10.3688 10.0459 10.9062 9.38027 10.9062ZM18.1959 18.5H16.1209V15.25C16.1209 14.475 16.1053 13.4781 15.0428 13.4781C13.9615 13.4781 13.7959 14.3219 13.7959 15.1938V18.5H11.7209V11.8187H13.7115V12.7312H13.7396C14.0178 12.2062 14.6959 11.6531 15.7053 11.6531C17.8053 11.6531 18.1959 13.0375 18.1959 14.8375V18.5Z",
    fill: "#0A0A0A"
  })));
};
export default SvgLinkedinSmall;